import { useEffect, useSyncExternalStore } from 'react';

export interface Focus {
  title?: string;
  progress?: string;
}

let current: Focus | null = null;
const subs = new Set<() => void>();

function set(next: Focus | null): void {
  current = next;
  for (const fn of subs) fn();
}

function subscribe(fn: () => void): () => void {
  subs.add(fn);
  return () => {
    subs.delete(fn);
  };
}

export function useQuestionFocus(title: string | undefined, progress: string | undefined): void {
  useEffect(() => {
    set({ title, progress });
  }, [title, progress]);
  useEffect(() => () => set(null), []);
}

export function useFocus(): Focus | null {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => null,
  );
}
